module.exports = __webpack_public_path__ + "media/images/web/home/index/header_bg_t-d7068c9dc3652b8e4bc03bcf87a8e8e1.jpg";